
import React, { useEffect, useState, useContext } from 'react'
import { ContentContext } from '../../Contexts/Contents/Context.js';
/* COMPONENTES */
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';

/* importação da class crud */
import ClassUseServiceSearch from './useServiceSearch';
import ClassUseServiceDelete from './useServiceDelete';

/* UTILITÁRIOS */
//import Permission from '../../utils/Permission.js'

import { usePaginator } from '../../utils/Paginator.js'
import { AuthContext } from '../../Contexts/Auth/AuthContext.js';

function useCase() {
    const { listData, setListData, getBroadcast, action, setAction, isLoading, setIsLoading, setBroadcast } = useContext(ContentContext)
    const { provider_user} = useContext(AuthContext)
    const { first, rows, onPageChange, template1 } = usePaginator();

    const [onResume, setOnResume] = useState({});
    const [getResult, setResult] = useState([]);
    const [error, setError] = useState(null);

    const data = {
        leftJoin: true,
        where: [],
        orderBy: "A.class_id DESC",
        countAllRows: true,
        page: 1,
        limit: 10
    }

    const refresh = (page, r) => {
        //console.clear();
        console.log('%c~ * ~ USECASE::refresh ~ * ~', 'color: white; background-color: blue; padding: 4px;font-size: 12px', page, r);
        reloadList({ page: page, limit: r });
    }

    const handlerDelete = async (data) => {
        ////console.clear();
        //console.log('%c~ * ~ URL ENVIADA A API - useCase :: DELETE ~ * ~', 'color: white; background-color: blue; padding: 4px;font-size: 18px');
        //console.log("- ", data);

        try {
            setIsLoading(true);
            const response = await new ClassUseServiceDelete().delete(data)
            const result = response.data.result;

            if (response.status == 200) {
                if (!!result.success.length) {
                    const newgetList = listData.filter(element => !result.success.includes(element.class_id));                    
                    setListData(newgetList);
                    setIsLoading(false);
                    setOnResume({ summary: "Concluído!", detail: "Exclusão bem sucedida.", severity: "success" });
                }

                if (!!result.fail.length) {
                    setOnResume({ summary: "Falha!", detail: "Há exclusões não efetivadas.", severity: "error" });
                    setBroadcast({
                        "page": "class",
                        "action": "post",
                        "segment": "list",
                        "command": "resetButtonDeleteGroup"
                    })
                }
            }

        } catch (error) {
            setOnResume({ summary: "Falha!", detail: "Não foi possível concluir a requisição", severity: "error" });
        }
        setIsLoading(false);
    }

    const reloadList = (newData) => {
        //console.clear();

        console.log('%c~ * ~ USECASE::reloadList ~ * ~', 'color: white; background-color: green; padding: 4px;font-size: 18px', newData);


        let sql = data;
        if (newData != null)
            sql = { ...data, ...newData };
        setIsLoading(true);
        const fetchData = async () => {
            try {                
                setIsLoading(true);
                const classUseServiceSearch = new ClassUseServiceSearch();
                let getResult2 = await classUseServiceSearch.execute(sql,provider_user.USER_TOKEN)
                console.log(":::: RESULTADO DA BUSCA DE TURMAS :::: ", getResult2.data);

                setListData(getResult2.data.result);
                setBroadcast({
                    "page": "class",
                    "action": "search",
                    "segment": "list",
                    "body": {
                        "command": "none"
                    },
                    "data": getResult2.data
                })                
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };

        fetchData();
    }

    useEffect(() => {        
        if (getBroadcast) {
            if (getBroadcast.command == "pagination") {
                console.log('%c~ * ~ USE EFFECT - getBroadcast::[] ~ * ~', 'color: #fff; background-color: blue; padding: 10px;', getBroadcast);
                refresh(getBroadcast.data.page, getBroadcast.data.rows)
            }
        }
    }, [getBroadcast])

    useEffect(() => {
        console.log('%c~ * ~ USE EFFECT - useCase::[] ~ * ~', 'color: #fff; background-color: #e34c26; padding: 10px;');
        
           
        
    }, []);
    

    function verificaPropriedades(a, b) {
        return b.map(b_item => {
            const matchingIndex = a.findIndex(el => el.class_id === b_item.class_id);
            if (matchingIndex !== -1) {
                return { ...b_item, ...a[matchingIndex] };
            }
            return b_item;
        });
    }
    useEffect(() => {        
        if (listData != null && action == "post") {
            setResult((current) => [...current, listData]);
        }

        if (listData != null && action == "patch") {
            const newResult = verificaPropriedades(listData, getResult);
            setAction("post")
            setResult(newResult);
        }

        if (listData != null && action == "search") {            
            setResult(listData);
        }
        setIsLoading(false);
    }, [listData]);

    useEffect(() => {
        let msg = "";
        if (error != null) {
            const data = error;
            if (data.status == 403) {
                msg = { summary: "Atenção!", detail: "data.resume.fail[0]", severity: "error" };
            } else {
                msg = { summary: "Falha!", detail: "Error", severity: "error" };
            }
            setOnResume(msg);
        }

    }, [error]);

    return { getResult, isLoading, onResume, first, rows, template1, handlerDelete, reloadList, onPageChange };
}

export default useCase;
        